import heic2any from 'heic2any'

const MAX_FILE_SIZE_MB = 15

export default async function processHeic(file, onStart = () => {}, onError = () => {}) {
  if (!file) return null

  const isHeic = file.type === 'image/heic' || (file.name && file.name.toLowerCase().endsWith('.heic'))
  if (!isHeic) return file

  if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
    onError(file.name, `Max ${MAX_FILE_SIZE_MB}MB`)
    return null
  }

  try {
    onStart(file.name)
    const convertedBlob = await heic2any({
      blob: file,
      toType: 'image/jpeg',
      quality: 0.8
    })

    const finalBlob = Array.isArray(convertedBlob) ? convertedBlob[0] : convertedBlob

    let newName = file.name.replace(/\.heic$/i, '')
    if (!newName.toLowerCase().endsWith('.jpg')) {
      newName += '.jpg'
    }

    return new File([finalBlob], newName, { type: 'image/jpeg' })
  } catch (error) {
    onError(file.name, 'Falha na conversão')
    return null
  }
}
